// import { useEffect, useRef, useState } from "react"

const PRICINGS_TERMS_BY_PERIOD_TYPE = {
   every_7: 'weekly_terms',
   every_14: 'bi_weekly_terms',
   every_30: 'monthly_terms',
   every_60: 'bi_monthly_terms',
   every_90: 'quarterly_terms',
   every_180: 'half_year_terms',
   every_365: 'yearly_terms',
   one_time: 'one_time_terms',
}

const PRICINGS_TYPES_BY_PERIODS = {
   '7': 'every_7',
   '14': 'every_14',
   '30': 'every_30',
   '60': 'every_60',
   '90': 'every_90',
   '180': 'every_180',
   '365': 'every_365',
   'one_time': 'one_time',
}
const PERIODS_NAME_BY_PRICING_PERIOD = {
   '7': 'weekly',
   '14': 'bi-weekly',
   '30': 'monthly',
   '60': 'bi-monthly',
   '90': 'quarterly',
   '180': 'half year',
   '365': 'year',
   'one_time': 'one-time',
}
const PERIODS_CAPITALIZED_NAME_BY_PRICING_PERIOD = {
   '7': 'Weekly',
   '14': 'Biweekly',
   '30': 'Monthly',
   '60': 'Bimonthly',
   '90': 'Quarterly',
   '180': 'Semiannually',
   '365': 'Yearly',
   'one_time': 'One-time',
}
const PERIODS_NAME_WITH_DAYS_BY_PRICING_PERIOD = {
   '7': 'every 7 days',
   '14': 'every 14 days',
   '30': 'every 30 days',
   '60': 'every 60 days',
   '90': 'every 90 days',
   '180': 'every 180 days',
   '365': 'every 365 days',
   'one_time': 'One-time',
}

const PERIODS_UPPERCASE_NAME_WITH_DAYS_BY_PRICING_PERIOD = {
   'every_7': 'Every 7 days',
   'every_14': 'Every 14 days',
   'every_30': 'Every 30 days',
   'every_60': 'Every 60 days',
   'every_90': 'Every 90 days',
   'every_180': 'Every 180 days',
   'every_365': 'Every 365 days',
   'one_time': 'One-time',
}

const PRICINGS_PERIODS_BY_TYPES = {
   'every_7': '7',
   'every_14': '14',
   'every_30': '30',
   'every_60': '60',
   'every_90': '90',
   'every_180': '180',
   'every_365': '365',
   'one_time': 'one_time',
}

const PRICINGS_PERIOD_TEXT_NAMES = {
   'every_7': 'weekly',
   'every_14': 'biweekly',
   'every_30': 'monthly',
   'every_60': 'bimonthly',
   'every_90': 'quarterly',
   'every_180': 'semiannually',
   'every_365': 'yearly',
   'one_time': 'one-time',
}

const DEFAULT_MEMBERSHIP_PERIOD = 'every_30'
const COMPARE_FIRST_PAGE_COUNT = 50

// window.show_compare_pagination_count = true

// membershipsDefaultFilterPeriodSelector value
const generateDefaultPeriodFilterValue = (membershipsDefaultFilterPeriod, membershipInfo, isUpgradePage = false) => {

   if(!membershipsDefaultFilterPeriod) {
      return DEFAULT_MEMBERSHIP_PERIOD
   }

   if(!membershipInfo?.recurring_period?.duration?.length) {
      if('one_time' === membershipsDefaultFilterPeriod) {
         if(isUpgradePage) {
            return DEFAULT_MEMBERSHIP_PERIOD
         }
         return membershipsDefaultFilterPeriod
      }

      return `every_${ membershipsDefaultFilterPeriod }`
   }

   if('one_time' === membershipsDefaultFilterPeriod && membershipInfo.recurring_period.duration.includes(membershipsDefaultFilterPeriod)) {
      return membershipsDefaultFilterPeriod
   }

   if(membershipInfo.recurring_period.duration.includes(Number(membershipsDefaultFilterPeriod))) {
      return `every_${ membershipsDefaultFilterPeriod }`
   }

   return DEFAULT_MEMBERSHIP_PERIOD
}

const getColsCount = (breakpoint, data) => {


   if(breakpoint === 1024) {
      return 1
   }

   if(breakpoint === 1439) {

      if(data?.length < 2) {
         return 1
      }

      return 2
   }

   if(breakpoint === 1910) {
      if(data?.length === 2) {
         return 2
      }
      if(data?.length === 1) {
         return 1
      }

      return 4

   }

   if(breakpoint === 'default') {
      if(data?.length === 1) {
         return 1
      }
      if(data?.length === 2) {
         return 2
      }
      if(data?.length === 3) {
         return 3
      }
      return 4
   }
}

// const useImageBrightness = ({ imageUrl }) => {
//    const [isDark, setIsDark] = useState(false);
//    const canvasRef = useRef(null);

//    useEffect(() => {
//       const detectBrightness = () => {
//          const canvas = canvasRef.current;
//          if(!canvas) return;

//          const ctx = canvas.getContext('2d');
//          const img = new Image();
//          img.crossOrigin = 'Anonymous'; // Essential for loading images from different origins
//          img.src = imageUrl;

//          img.onload = () => {
//             canvas.width = img.width;
//             canvas.height = img.height;
//             ctx.drawImage(img, 0, 0, img.width, img.height);

//             const imageData = ctx.getImageData(0, 0, img.width, img.height);
//             const data = imageData.data;
//             let totalBrightness = 0;

//             // Iterate through pixels and calculate average brightness
//             for(let i = 0; i < data.length; i += 4) {
//                const r = data[i];
//                const g = data[i + 1];
//                const b = data[i + 2];
//                // Calculate perceived brightness using a common formula
//                const brightness = (0.299 * r + 0.587 * g + 0.114 * b);
//                totalBrightness += brightness;
//             }

//             const averageBrightness = totalBrightness / (data.length / 4);
//             // Define a threshold to determine "dark" or "light"
//             setIsDark(averageBrightness < 128); // 128 is a common threshold for a 0-255 scale
//          };

//          img.onerror = (error) => {
//             console.error("Error loading image:", error);
//             setIsDark(false); // Default to light if image fails to load
//          };
//       };

//       if(imageUrl) {
//          detectBrightness();
//       }
//    }, [imageUrl]);

//    return ({
//       view: <div>
//          <div style={ { backgroundColor: isDark ? 'white' : 'black', color: isDark ? 'black' : 'white', padding: '20px' } }>
//             {isDark ? 'This background is dark!' : 'This background is light!'}
//          </div>
//          <canvas ref={ canvasRef } style={ { display: 'none' } }></canvas> {/* Hidden canvas for image processing */}
//       </div>,
//       isDarkBackground: isDark,
//    }
//    );
// };

const sortBenefitsByDefault = (benefits) => {
   return benefits.sort((a, b) => {
      const getPriority = (item) => {
         if(item.is_auto === true && item.key?.includes('photosets_access_benefit')) return 1;
         if(item.is_auto === true && item.key?.includes('videos_access_benefit')) return 2;
         if(item.is_auto === true && item.key?.includes('livestreams_access_benefit')) return 3;
         if(item.is_auto === true && item.key?.includes('photosets_download_benefit')) return 4;
         if(item.is_auto === true && item.key?.includes('videos_download_benefit')) return 5;
         if(item.is_auto === true && item.key?.includes('custom_page_benefit')) return 6;
         if(item.is_auto === true && item.key?.includes('chat_text_benefit')) return 7;
         if(item.is_auto === true && item.key?.includes('chat_image_benefit')) return 8;
         if(item.is_auto === true && item.key?.includes('chat_voice_benefit')) return 9;
         if(item.is_auto !== true) return 10;
         return 11; // fallback for undefined/missing keys
      };

      return getPriority(a) - getPriority(b);
   });
};

const getMembershipsGridStyles = (data) => ({
   [`grid py-4 lg:py-6 gap-[14px] justify-center`]: true,
   // [`grid-cols-[repeat(3,_minmax(0,_432px))]`]: (window?.innerWidth >= 1440 && window?.innerWidth < 1910 && data?.length === 3) || (window?.innerWidth >= 1440 && data?.length >= 3),
   [`grid-cols-[repeat(1,_minmax(0,_427px))]`]: window?.innerWidth <= 1024 || data?.length === 1,
   [`grid-cols-[repeat(3,_minmax(0,_427px))] `]: (window?.innerWidth > 1024 && window?.innerWidth < 1440 && data?.length === 2) || (window?.innerWidth > 1024 && data?.length >= 2),
   [`grid-cols-[repeat(4,_minmax(319px,_427px))]`]: (window?.innerWidth >= 1440 && data?.length >= 4),
   [`grid-cols-[repeat(5,_minmax(0,_432px))]`]: (window?.innerWidth >= 2160 && data?.length > 4),
   [`w-full px-[25%]`]: (data?.length === 1 && window?.innerWidth >= 1024),
   [`!grid-cols-[repeat(2,_minmax(0,_432px))]`]: (window?.innerWidth >= 1024 && data?.length === 2),
})

const getCompareStateAfterPagination = (oldData = [], newData = [], filter = {}, isLoadMore) => {

   let compareData = [...oldData]
   const { media_types } = filter

   return newData.map(mb => {
      const currentContentAccessData = compareData.find(it => it?.id === mb.id)?.content_access_data
      const incomingContentAccessData = mb?.content_access_data
      const clickedType = media_types.split(',')?.[0]

      const newAccessData = Object.keys(incomingContentAccessData).reduce((prev, curr) => {
         const existingContentlist = currentContentAccessData?.[curr]
         const newContentList = incomingContentAccessData?.[curr]?.filter(it => !(existingContentlist.map(it => it.id).includes(it?.id)))


         if(curr === 'custom_pages') {
            // console.log({ existingContentlist, newContentList, clickedType });
            if(curr === clickedType) {
               if(newContentList?.length > 0) {
                  if(isLoadMore) {
                     prev[curr] = [...existingContentlist, ...newContentList] || []
                  } else {
                     prev[curr] = [...existingContentlist] || []
                  }
               } else {
                  prev[curr] = []
               }
            } else {
               prev[curr] = currentContentAccessData?.[curr] || []
            }
         } else {
            // console.log({ existingContentlist, newContentList, clickedType });

            if(curr === clickedType) {
               if(newContentList?.length > 0) {
                  if(isLoadMore) {
                     // console.log(44444);
                     prev[curr] = [...existingContentlist, ...newContentList] || []
                  } else {
                     // console.log(88888);
                     prev[curr] = [...existingContentlist].slice(0, COMPARE_FIRST_PAGE_COUNT) || []
                  }
               } else {
                  prev[curr] = [...existingContentlist].slice(0, COMPARE_FIRST_PAGE_COUNT) || []

               }
            } else {
               prev[curr] = currentContentAccessData?.[curr] || []
            }
         }

         return prev

      }, {})

      let newMembership = { ...mb }

      // console.log({ newAccessData });


      newMembership = {
         ...newMembership,
         content_access_data: {
            ...newAccessData,
         },
      }

      return newMembership

   })
}

const defaultOffsets = {
   "custom_pages_offset": [
      0,
      0,
   ],
   "videos_pages_offset": [
      0,
      COMPARE_FIRST_PAGE_COUNT,
   ],
   "photosets_pages_offset": [
      0,
      COMPARE_FIRST_PAGE_COUNT,
   ],
   "livestreams_pages_offset": [
      0,
      COMPARE_FIRST_PAGE_COUNT,
   ],
}

const defaultMediaTypes = 'custom,videos,photosets,livestreams'

const generatePurchaseRouteId = (data, type) => {
   const currentPeriod =  data?.pricing_payload?.[type]?.recurring_period
   return `${ data?.id }-${ currentPeriod }`
}
/// Old compare state after pagination

// if(media_types?.includes('photosets')) {
//    newData = newData.map(mb => {
//       const existingContentlist = [] // compareData.find(it => it?.id === mb.id)?.content_access_data?.photosets

//       if(existingContentlist?.length > 0) {
//          return {
//             ...mb,
//             content_access_data: {
//                ...mb?.content_access_data,
//                photosets: [...existingContentlist, ...mb?.content_access_data?.photosets],
//             },
//          }
//       } else {
//          return {
//             ...mb,
//          }

//       }
//    })
// }
// if(media_types?.includes('videos')) {
//    newData = newData.map(mb => {
//       const existingContentlist = [] // compareData.find(it => it?.id === mb.id)?.content_access_data?.videos

//       if(existingContentlist?.length > 0) {
//          return {
//             ...mb,
//             content_access_data: {
//                ...mb?.content_access_data,
//                videos: [...existingContentlist, ...mb?.content_access_data?.videos],
//             },
//          }
//       } else {
//          return {
//             ...mb,
//          }

//       }
//    })
// }
// if(media_types?.includes('livestreams')) {
//    newData = newData.map(mb => {
//       const existingContentlist = [] // compareData.find(it => it?.id === mb.id)?.content_access_data?.livestreams

//       if(existingContentlist?.length > 0) {
//          return {
//             ...mb,
//             content_access_data: {
//                ...mb?.content_access_data,
//                livestreams: [...existingContentlist, ...mb?.content_access_data?.livestreams],
//             },
//          }
//       } else {
//          return {
//             ...mb,
//          }

//       }
//    })
// }

export {
   PRICINGS_TERMS_BY_PERIOD_TYPE,
   PRICINGS_TYPES_BY_PERIODS,
   DEFAULT_MEMBERSHIP_PERIOD,
   PRICINGS_PERIODS_BY_TYPES,
   // DEFAULT_MEMBERSHIPS_LIMIT,
   PERIODS_NAME_BY_PRICING_PERIOD,
   PERIODS_CAPITALIZED_NAME_BY_PRICING_PERIOD,
   PERIODS_NAME_WITH_DAYS_BY_PRICING_PERIOD,
   COMPARE_FIRST_PAGE_COUNT,
   getColsCount,
   // useImageBrightness,
   sortBenefitsByDefault,
   PRICINGS_PERIOD_TEXT_NAMES,
   getMembershipsGridStyles,
   PERIODS_UPPERCASE_NAME_WITH_DAYS_BY_PRICING_PERIOD,
   defaultOffsets,
   defaultMediaTypes,
   getCompareStateAfterPagination,
   generatePurchaseRouteId,
   generateDefaultPeriodFilterValue,
}
